import styles from "./Button.module.scss";
import cn from "classnames";
import { Loader } from "@components/new/Loader";
import { ButtonSize, ButtonType } from "./types.ts";

interface ButtonProps {
  title?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  type?: ButtonType;
  size?: ButtonSize;
  loading?: boolean | undefined;
  disabled?: boolean | undefined;
  icon?: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  suffix?: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  iconClassName?: string;
  isWide?: boolean;
}

export const Button = ({
  type: btnType_,
  size,
  disabled,
  className,
  icon,
  iconClassName,
  suffix,
  loading,
  title,
  onClick,
  isWide,
}: ButtonProps) => {
  const btnType = btnType_ || ButtonType.PRIMARY;
  const btnSize = size || ButtonSize.L;

  const handleOnClick = (e: any) => {
    e.stopPropagation();
    if (!disabled && !loading && onClick) onClick();
  }

  return (
    <button
      onClick={handleOnClick}
      className={cn(
        styles.button,
        className,
        styles[btnType],
        styles[`size-${btnSize}`],
        loading && styles.buttonLoading,
        isWide && styles.wide,
      )}
      disabled={disabled}
      type="button"
    >
      {loading ? (
        <Loader className={styles.loader} />
      ) : null}
      <div className={styles.content}>
        {icon && (
          <div className={cn(
            styles.icon,
            iconClassName,
          )}>
            {typeof icon === "string" && (
              <img alt="icon" src={icon} />
            )}
            {typeof icon === "function" && icon({})}
          </div>
        )}
        {title}
        {suffix && (
          <div className={cn(
            styles.icon,
            // iconClassName,
          )}>
            {typeof suffix === "string" && (
              <img alt="icon" src={suffix} />
            )}
            {typeof suffix === "function" && suffix({})}
          </div>
        )}
      </div>
    </button>
  );
};
